import { Stack, Typography, styled, type CSSObject } from '@mui/material';

import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const SorobanScanPromoSection = styled(Section)(({ theme }) => ({
  margin: theme.spacing(16, 0, 16, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(15, 0, 15, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(9, 0, 9, 0),
  },
}));

export const StyledCard = styled(Stack)(({ theme }) => ({
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(6),
  width: '100%',
  padding: theme.spacing(7, 8),
  borderRadius: theme.spacing(3),
  overflow: 'hidden',
  background: theme.palette.greyBackgroundColor?.INVERTED,
  border: '1px solid rgba(255, 217, 0, 0.35)',
  boxShadow:
    '0px 0px 80px 0px rgba(255, 217, 0, 0.12), inset 0px 1px 0px 0px rgba(255, 255, 255, 0.06)',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(5, 4),
    gap: theme.spacing(4),
  },
}));

export const StyledGlow = styled('div')(() => ({
  position: 'absolute',
  top: '-30%',
  left: '30%',
  width: '55%',
  height: '160%',
  background:
    'radial-gradient(circle, rgba(255, 217, 0, 0.18) 0%, transparent 70%)',
  filter: 'blur(80px)',
  pointerEvents: 'none',
  zIndex: 0,
}));

export const StyledTextStack = styled(Stack)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  flex: '0 1 40%',
  gap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    flex: '1 1 auto',
  },
}));

export const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));

export const StyledHeading = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  fontWeight: 900,
  fontSize: `${theme.utils.fluidSize({ minSize: 32, maxSize: 44 })} !important`,
  lineHeight: '1.15 !important',
  letterSpacing: '-0.02em',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  maxWidth: 480,
  color: theme.palette.invertedContent?.SECONDARY,
  fontSize: '16px',
  lineHeight: '26px',
}));

export const StyledButtonLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  marginTop: theme.spacing(1),
  padding: theme.spacing(1.5, 4),
  borderRadius: theme.spacing(4),
  border: '1px solid #FFD900',
  background: 'rgba(255, 217, 0, 0.06)',
  color: theme.palette.invertedContent?.PRIMARY,
  fontFamily: 'Satoshi',
  fontWeight: 650,
  fontSize: '16px',
  textDecoration: 'none',
  transition: 'background 0.25s ease, box-shadow 0.25s ease',
  '&:hover': {
    background: 'rgba(255, 217, 0, 0.14)',
    boxShadow: '0px 0px 24px 0px rgba(255, 217, 0, 0.35)',
  },
}));

export const StyledImageWrapper = styled('a')(({ theme }) => ({
  display: 'block',
  position: 'relative',
  zIndex: 1,
  flex: '0 1 60%',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    flex: '1 1 auto',
  },
}));

export const StyledImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: 'auto',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 24px 60px 0px rgba(0, 0, 0, 0.45)',
}));
